module.exports = __webpack_public_path__ + "static/media/rb_jing_xi.8e7b8fee.png";